import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function NoDataFallback() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4 p-8 items-center">
      <FontAwesomeIcon
        icon={faSearch}
        size="3x"
        className="text-neutrals-N800 mx-auto"
      />
      <span className="text-md">
        {t('domain.arbeitszeiten.uebersicht.noResults.title')}
      </span>
      <span className="text-xs text-neutrals-N600">
        {t('domain.arbeitszeiten.uebersicht.noResults.subtitle')}
      </span>
    </div>
  );
}
